import getItemListData from './get-item-list-data';

const getItemListIds = data => {
  const itemListElements = getItemListData(data);
  return itemListElements.length
    ? itemListElements.map(({ itemId }) => ({ displayItems: [itemId] }))
    : null;
};

export default getItemListIds;
